import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import { Search } from "@material-ui/icons"
import CheckIcon from "@material-ui/icons/Check" // import PathContext from "~/contexts/Path"
import clsx from "clsx"
import { useContext, useEffect, useState } from "react"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { useHistory } from "react-router-dom"
import { useDebounce } from "use-lodash-debounce"
import {
  createArticle,
  deleteArticle,
  listArticles,
  updateArticle,
} from "~/actions/categories"
import trash from "~/assets/Icons/feather-trash-2.svg"
import ThumbnailUpload from "~/components/Common/ThumbnailUpload"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AppContext from "~/contexts/App"
import CategoryContext from "~/contexts/Category"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"

// import AddCourseCard from "./CourseCard"
import Box from "~/components/Common/Box"
import useStyles from "./styles"

const AddArticleDialog = () => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const { dialogs, closeDialog, openSnackBar } = useContext(AppContext)
  const {
    setCategoryArticles,
    categoryArticles,
    refetchCategory,
    articleDetailValues,
    setArticleDetailValues,
    selectedArticle,
    setSelectedArticle,
  } = useContext(CategoryContext)

  const thisDialog = dialogs?.["addArticleDialog"] || {}
  const { open = false, data } = thisDialog
  const { data: articles, refetch: refetchArticles } = useQuery(
    "articles",
    () => listArticles(),
  )
  const openErrorSnackbar = useOpenErrorSnackbar()
  const queryClient = useQueryClient()
  const [searchValue, setSearchValue] = useState("")
  const [searchedArticles, setSearchedArticles] = useState([])
  const [addedArticles, setAddedArticles] = useState([])
  const [createSectionOpen, setCreateSectionOpen] = useState(false)
  const [debouncedDetails, setDebouncedDetails] = useState([])

  const [selectedArticles, setSelectedArticles] = useState([])

  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  let type = thisDialog?.data?.type

  useEffect(() => {
    let holder = [...selectedArticles]
    categoryArticles.map((x) => {
      holder.find((y) => y?.id === x?.id) === undefined && holder.push(x)
    })
    setSelectedArticles(holder)
  }, [open])

  const handleClose = (cancel = false) => {
    if (cancel) {
      closeDialog("addArticleDialog", true, null)
      setCreateSectionOpen(false)
    } else {
      closeDialog("addArticleDialog", true, addedArticles)
      // setCreateSectionOpen(false)
    }
    setSelectedArticle({})
    setArticleDetailValues({})
    setSearchValue("")
    setAddedArticles([])
  }

  const openCreateSection = () => {
    setCreateSectionOpen(!createSectionOpen)
    setSelectedArticle({})
    setArticleDetailValues({})
  }

  const closeCreateSection = () => {
    setCreateSectionOpen(false)
    setSelectedArticle({})
    setArticleDetailValues({})
  }

  const handleSelectArticle = (article) => {
    if (selectedArticles?.find((x) => x?.id === article?.id)) {
      setSelectedArticles((oldArticles) => {
        const uniqueArticles = [
          ...new Map(
            oldArticles.map((oldArticle) => [oldArticle?.id, oldArticle]),
          ).values(),
        ]
        return uniqueArticles.filter((x) => x?.id !== article?.id)
      })
    } else {
      setSelectedArticles((oldArticles) => {
        const uniqueArticles = [
          ...new Map(
            oldArticles.map((oldArticle) => [oldArticle?.id, oldArticle]),
          ).values(),
        ]
        return [...uniqueArticles, article]
      })
    }
  }

  const handleAddSelected = () => {
    // update category mutation with articles
    setCategoryArticles(selectedArticles)
    handleClose()
  }

  const docDefaultImage =
    "https://a-us.storyblok.com/f/1001834/1200x676/0453d4e8bb/doc-default-cover.png"
  const updateDefaultImage =
    "https://a-us.storyblok.com/f/1001834/1200x676/bb6b2793f3/update-default-cover.png"

  const debouncedLocalValues = useDebounce(articleDetailValues, 200)
  useEffect(() => {
    setDebouncedDetails(articleDetailValues)
  }, [debouncedLocalValues])

  const updateArticleMutation = useMutation((data) =>
    updateArticle(selectedArticle.id, data),
  )

  const createArticleMutation = useMutation(createArticle)

  const deleteArticleMutation = useMutation((data) =>
    deleteArticle(data.id, data),
  )

  useEffect(() => {
    if (data?.openUpdate) {
      setCreateSectionOpen(true)
      setSelectedArticle(data.article)
      setArticleDetailValues(data.article)
    }
  }, [data])

  const onCreateSubmit = (values) => {
    createArticleMutation.mutate(values, {
      onSuccess: (res) => {
        queryClient.setQueryData("articles", (oldData) => {
          return [...oldData, res.data]
        })
        setSelectedArticle(res.data)
        setArticleDetailValues(res.data)
        setSearchedArticles((oldData) => [...oldData, res.data])

        openSnackBar({
          message: `${type?.toUpperCase() + " Created"}`,
        })
      },
      onError: (err) => {
        console.error(err)
        // actions.setSubmitting(false)
        openErrorSnackbar(err, `There was an error creating a ${type}`)
      },
    })
  }

  const onUpdateSubmit = (values) => {
    updateArticleMutation.mutate(values, {
      onSuccess: (res) => {
        queryClient.setQueryData("articles", (oldData) => {
          let filteredOldData = [...oldData].filter(
            (x) => x.id !== res.data.article.id,
          )

          return [...filteredOldData, res.data]
        })
        setSelectedArticle(res.data.article)
        setArticleDetailValues(res.data.article)
        setSearchedArticles((oldData) => {
          let newArray = oldData.map((x) => {
            if (x.id !== res.data.article.id) {
              return x
            } else {
              return res.data.article
            }
          })
          return [...newArray]
        })

        openSnackBar({
          message: `${type?.toUpperCase() + " Updated"}`,
        })
      },
      onError: (err) => {
        console.error(err)
        // actions.setSubmitting(false)
        openErrorSnackbar(err, `There was an error creating a ${type}`)
      },
    })
  }

  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(-1)

  const onDeleteSubmit = (values) => {
    deleteArticleMutation.mutate(values, {
      onSuccess: (res) => {
        queryClient.setQueryData("articles", (oldData) => {
          return [...res.data]
        })

        setDeleteConfirmOpen(false)
        // setArticle(res.data)
        setCategoryArticles(res.data)
        setArticleDetailValues(res.data)
        setSearchedArticles([...res.data])

        // setSelectedArticles(res.data)
        refetchCategory()
        refetchArticles()
        openSnackBar({
          message: `${type?.toUpperCase() + " Removed"}`,
        })
      },
      onError: (err) => {
        console.error(err)
        // actions.setSubmitting(false)
        openErrorSnackbar(err, `There was an error deleting the ${type}`)
      },
    })
  }

  // fitered data using searchValue
  useEffect(() => {
    if (articles) {
      let newArray = [...articles]
      if (searchValue.length > 0) {
        newArray = articles?.filter((article) => {
          return article?.title
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        })
      } else if (searchValue === "") {
        newArray = articles
      }
      setSearchedArticles(newArray)
    }
  }, [searchValue])

  const setThumbnail = (uploadRes, loadingAction, type) => {
    const image =
      uploadRes === null
        ? selectedArticle?.type === "doc"
          ? { url: docDefaultImage }
          : selectedArticle?.type === "update"
            ? { url: updateDefaultImage }
            : null
        : {
            url: uploadRes.data.url,
            secure_url: uploadRes.data.secure_url,
            original_filename: uploadRes.data.original_filename,
            version: uploadRes.data.version,
            format: uploadRes.data.format,
            public_id: uploadRes.data.public_id,
          }

    const data = {
      ...articleDetailValues,
      [type]: image === null ? null : JSON.stringify(image),
    }
    updateArticleMutation.mutate(data, {
      onSuccess: (res) => {
        queryClient.setQueryData("articles", (oldData) => {
          let newArray = []
          newArray = oldData.map((x) => {
            if (x.id !== res.data.article.id) {
              return x
            } else {
              x.image = res.data.article.image
              return x
            }
          })
          return [...newArray]
        })
        // return

        // refetchCategory()
        setSelectedArticle(res.data.article)
        setArticleDetailValues(res.data.article)
        refetchArticles()
        loadingAction(false)
      },
      onError: (err) => {
        console.error(err)
        loadingAction(false)
        openErrorSnackbar(err, "Error Updating Thumbnail")
      },
    })
  }

  const handleUpdateOpen = (article) => {
    setSelectedArticle(article)
    setArticleDetailValues(article)
    setCreateSectionOpen(true)
    return
  }

  // const filteredArticles = articles?.filter((x) => x?.type === type)

  const filteredArticles = searchedArticles?.filter((x) => x?.type === type)

  const createSection = () => {
    return (
      <div className="h-full relative mt-2">
        <Typography color="secondary" className={classes.inputLabel}>
          Article Name
        </Typography>
        <TextField
          value={articleDetailValues?.title || ""}
          onChange={(e) => {
            setArticleDetailValues((oldState) => ({
              ...oldState,
              title: e.target.value,
              type: selectedArticle?.type,
              image:
                !selectedArticle?.image && type === "doc"
                  ? JSON.stringify({ url: docDefaultImage })
                  : !selectedArticle?.image && type === "update"
                    ? JSON.stringify({ url: updateDefaultImage })
                    : selectedArticle.image,
            }))
          }}
          style={{ marginBottom: "10px" }}
          InputProps={{
            classes: {
              root: classes.inputBackgroundColor,
            },
          }}
          variant="filled"
          size="small"
          fullWidth
        />
        {selectedArticle?.id && (
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Typography color="secondary" className={classes.title}>
                Article Link To
              </Typography>
              <TextField
                value={articleDetailValues?.link || ""}
                onChange={(e) => {
                  setArticleDetailValues((oldState) => ({
                    ...oldState,
                    title: selectedArticle?.title,
                    link: e.target.value,
                    type: selectedArticle?.type,
                    image: selectedArticle?.image,
                  }))
                }}
                style={{ marginBottom: "10px" }}
                InputProps={{
                  classes: {
                    root: classes.inputBackgroundColor,
                  },
                }}
                variant="filled"
                size="small"
                fullWidth
              />
            </div>
            <div>
              <Box width="100%">
                <Typography color="secondary" className={classes.inputLabel}>
                  Article Image
                </Typography>
                <>
                  <div className="bg-gray-300">
                    {/* //TODO location 1 */}
                    <ThumbnailUpload
                      title="Drop small image here"
                      cloudinaryUploadPreset={
                        import.meta.env.VITE_CLOUDINARY_CLOUD_THUMBNAIL_UPLOAD
                      }
                      value={
                        selectedArticle?.image &&
                        JSON.parse(selectedArticle?.image)
                      }
                      onUpload={setThumbnail}
                      noCrop={true}
                      type="image"
                    />
                  </div>
                  {selectedArticle?.image &&
                  JSON.parse(selectedArticle?.image)?.original_filename ? (
                    <Typography variant="h4" className={classes.mediaKey}>
                      {JSON.parse(selectedArticle?.image)?.original_filename}.
                      {JSON.parse(selectedArticle?.image)?.format}
                    </Typography>
                  ) : (
                    <Typography variant="h4" className="mt-4">
                      Using Default Image
                    </Typography>
                  )}
                </>
              </Box>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <Dialog
      classes={
        // { paperWidthSm: classes.dialogContainer }
        !createSectionOpen
          ? { paperWidthSm: classes.dialogContainer }
          : { paperWidthSm: classes.dialogContainerDark }
      }
      open={open}
      fullScreen={smDown}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className={classes.dialogTop}
        >
          <Typography variant="h2" className={classes.title}>
            Add Article
          </Typography>
          {/* //TODO SEARCH FUNCTIONALITY */}
          {!createSectionOpen && (
            <TextField
              placeholder="Search articles"
              className={classes.search}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  setSearchValue(e.target.value)
                }
              }}
              onChange={(e) => e.target.value === "" && setSearchValue("")}
              InputProps={{
                disableUnderline: true,
                startAdornment: (
                  <InputAdornment
                    position="start"
                    style={{ marginLeft: "10px" }}
                  >
                    <Search className={classes.searchIcon} />
                  </InputAdornment>
                ),
              }}
            />
          )}
        </Box>
      </DialogTitle>

      <DialogContent
        className={createSectionOpen ? "overflow-hidden" : "overflow-auto"}
      >
        {!articles || !addedArticles ? (
          <CircularProgress />
        ) : (
          <>
            {!createSectionOpen && (
              <div className="grid grid-cols-3 gap-4 relative overflow-hidden">
                {filteredArticles?.map((article, i) => {
                  return (
                    <div
                      key={i}
                      className={clsx(
                        "flex flex-col border rounded-xl",
                        !selectedArticles?.find((x) => x?.id === article?.id)
                          ? "shadow-sm bg-[#e5e7eb8e] border-1 hover:bg-[#e5e7ebed]"
                          : "border-[#00EBFF] bg-[#00eaff51] border-1",
                      )}
                      onClick={(e) => {
                        // e.preventDefault()
                        handleSelectArticle(article)
                      }}
                      role="button"
                      tabIndex={-1}
                      onKeyDown={(e) => {
                        return
                      }}
                    >
                      <div className="flex flex-col gap-1 h-full">
                        <img
                          src={article?.image && JSON.parse(article?.image).url}
                          alt={article?.title + " " + article?.type}
                          className="w-full rounded-t-xl"
                        />
                        <div className="px-2">
                          {/* )} */}
                          <p className="text-xl font-medium">
                            {article?.title}
                          </p>
                          <p className="text-md italic">{article?.type}</p>
                          <p className="text-md break-all underline">
                            {article?.link}
                          </p>
                          <div className="flex justify-between">
                            <Button
                              onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                handleUpdateOpen(article)
                              }}
                              style={{ height: "40px", marginRight: "10px" }}
                            >
                              Update
                            </Button>
                            {deleteConfirmOpen !== article?.id && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation()
                                  setDeleteConfirmOpen(article?.id)
                                }}
                              >
                                <img src={trash} alt="Delete" />
                              </button>
                            )}
                            {deleteConfirmOpen === article?.id && (
                              <span className="flex items-center justify-center gap-1">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setDeleteConfirmOpen(-1)
                                  }}
                                  className="text-lg text-red-600"
                                >
                                  X
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    onDeleteSubmit(article)
                                  }}
                                >
                                  <CheckIcon className="fill-[#5cb85c]" />
                                </button>
                                {/* <p className="w-min opacity-70 text-xs">
                              Confirm Delete
                            </p> */}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
            {/* // filteredCourses?.map((course) => {
          //   return (
          //     <AddCourseCard
          //       course={course}
          //       key={course.id}
          //       addedArticles={addedArticles}
          //       setAddedArticles={setAddedArticles}
          //     />
          //   )
          // }) */}
            {createSectionOpen && createSection()}
          </>
        )}
      </DialogContent>
      <DialogActions
        style={{
          position: "relative",
          bottom: 4,
          width: "100%",
        }}
        className={classes.actions}
      >
        <div className="flex flex-col w-full relative mx-6">
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            // marginLeft="20px"
            marginRight="20px"
            className={classes.actionBox}
          >
            <Box>
              <Button
                className={classes.remove}
                onClick={() =>
                  Object.keys(selectedArticle).length === 0
                    ? openCreateSection()
                    : closeCreateSection()
                }
              >
                {!createSectionOpen
                  ? "Create Article"
                  : !selectedArticle.title
                    ? "Cancel Create"
                    : "Close Update"}
              </Button>
            </Box>
            <Box>
              <Button
                onClick={() => handleClose(true)}
                style={{ height: "40px", marginRight: "10px" }}
              >
                Close All
              </Button>
              <LoaderButton
                onClick={() =>
                  !createSectionOpen
                    ? handleAddSelected()
                    : !selectedArticle?.id
                      ? onCreateSubmit({ ...articleDetailValues, type: type })
                      : onUpdateSubmit({ ...articleDetailValues })
                }
                classoverrides={{
                  wrapper: classes.button,
                  button: {
                    root: classes.buttonRoot,
                  },
                }}
                variant="contained"
                color="secondary"
                //   working={isSubmitting}
                size="small"
              >
                {!createSectionOpen
                  ? "add"
                  : selectedArticle?.id
                    ? "update"
                    : "create"}
              </LoaderButton>
            </Box>
          </Box>
        </div>
      </DialogActions>
    </Dialog>
  )
}

AddArticleDialog.propTypes = {}

export default AddArticleDialog
